import { Component, EventEmitter, Output } from '@angular/core';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';

@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrl: './google-maps.component.scss',
  standalone: true,
  imports: [GoogleMap, MapAdvancedMarker]
})
export class GoogleMapsComponent {

  @Output() mapClick = new EventEmitter<google.maps.MapMouseEvent>();

  constructor() {
    if (navigator.geolocation && !this.center) {
      navigator.geolocation.getCurrentPosition(p => {
        this.center = {
          lat: p.coords.latitude,
          lng: p.coords.longitude
        };
      }, null, { enableHighAccuracy: true });
    }
  }

  center: google.maps.LatLngLiteral = { lat: 42.6, lng: 24.9 };
  zoom = 7;
  markerOptions: google.maps.marker.AdvancedMarkerElement;
  markerPosition: google.maps.LatLngLiteral;

  moveMap(event: google.maps.MapMouseEvent) {
    this.mapClick.emit(event);
    this.setCenter(event.latLng.toJSON());
    this.setMarkerAtCenter();
  }

  setCenter(center: google.maps.LatLngLiteral) {
    this.center = center;
  }

  setMarkerEventHandler(event: google.maps.MapMouseEvent) {
    this.markerPosition = event.latLng.toJSON();
  }

  setMarkerAtCenter() {
    this.markerPosition = this.center;
  }
}